import DateInput from "../../forms/DateInput";
import DateRangeInput from "../../forms/DateRangeInput";
import { DropDownList } from "@progress/kendo-react-dropdowns";

/**
 * Date filter cell component
 */
const DateFilterCell = (props) => {
  const { value, onChange, operator, operators, field, type, tdProps } = props;
  const handleChange = (name, newValue, e) => {
    if (operator === "between" && value?.start && value?.end && (newValue.start === null || newValue.end === null)) {
      //clean value
      newValue = null
    }
    onChange({
      value: newValue,
      operator: newValue ? (operator ? operator : "eq") : "",
      nativeEvent: e ? e.nativeEvent : new Event("change"),
      syntheticEvent: e ? e.syntheticEvent : new Event("change"),
    });
  };

  const handleOperatorChange = (e) => {
    const newOperator = e.target.value.operator;
    const isDate = value instanceof Date;

    const newValue = (isDate && newOperator === "between") || (!isDate && newOperator !== "between") ? null : value;
    onChange({
      value: newValue,
      operator: newOperator,
      nativeEvent: e.nativeEvent,
      syntheticEvent: e.syntheticEvent,
    });
  };

  const operatorValue = (operators && operators.find((x) => x.operator === operator)) || null;

  const element = <div className={"k-filtercell"}>
    <div className={"k-filtercell-wrapper"}>
      {operator === "between" ? (
        <DateRangeInput
          noFormInput={true}
          name={field}
          onChange={handleChange}
          value={value}
          format={"dd.MM.yyyy"}
          calendarSettings={{
            bottomView: "month",
            topView: "year",
            views: 3,
          }}
        />
      ) : (
        <DateInput noFormInput={true} type={type?.replace("input", "") || 'date'} onChange={handleChange} value={value} format={"dd.MM.yyyy"} name={props.field} todayHidden={true} validationHidden={true} />
      )}
      <div className={"k-filtercell-operator"}>
        <DropDownList className={"k-dropdown-operator"} data={operators} textField={"text"} value={operatorValue} onChange={handleOperatorChange} iconClassName={"k-icon k-font-icon k-i-filter"} popupSettings={{ width: "" }} />
      </div>
    </div>
  </div>

  return tdProps ?
    (
      <td
        aria-label={tdProps.ariaLabel}
        aria-colindex={tdProps.ariaColumnIndex}
        className={tdProps.className}
        style={tdProps.style}
        role={tdProps.role}
      >
        {element}
      </td>
    ) : element;
};

export default DateFilterCell;
